module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/assets/fonts/data-table/data-table.eot
// module id = ../../../../../src/assets/fonts/data-table/data-table.eot
// module chunks = styles